import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PowerBiView, UserReportViewType } from '../models';
import { useSelector } from 'react-redux';
import { selectIsWashClub } from '../../../store/themeReducer';

export const PermissionViewButtons = ({
  permissionLevel,
  view,
  changeView,
  includesSingle,
  currentPageName,
  intl,
  handleUploadPAndL,
}) => {
  const isWashClub = useSelector(selectIsWashClub);
  const renderSingleViewButton = (isActive = true) => (
    <button
      className={classNames(
        isActive ? 'powerbi-active' : 'powerbi-inactive',
        'powerbi-right-buttons',
        isActive && 'powerbi-left-buttons'
      )}
      onClick={!isActive ? () => changeView(PowerBiView.Single) : null}
      id="SingleView"
    >
      {intl.formatMessage({ id: 'singleSiteView' })}
    </button>
  );

  const renderMultiViewButton = (isActive) => (
    <button
      className={classNames(
        isActive ? 'powerbi-active' : 'powerbi-inactive',
        'powerbi-left-buttons'
      )}
      onClick={!isActive ? () => changeView(PowerBiView.Multi) : null}
      id="MultiView"
    >
      {intl.formatMessage({ id: 'multiSiteView' })}
    </button>
  );

  if (permissionLevel === UserReportViewType.Single) {
    return <div className="powerbi-button-container">{renderSingleViewButton()}</div>;
  }

  const uploadPAndLPages = [
    'ReportSection118eea27caaa60009478',
    'ReportSection906c448a65005746ab2d',
    'ReportSection7ad463e6ce2cd9b8cc54',
    'ReportSectionb61fee8cb9c090a404a3',
  ];

  return (
    <div className="powerbi-button-container row">
      <div className="col-md-6">
        {permissionLevel === UserReportViewType.Single ||
          (includesSingle && renderSingleViewButton(view === PowerBiView.Single))}
        {permissionLevel === UserReportViewType.Multi &&
          renderMultiViewButton(view === PowerBiView.Multi)}
      </div>
      {!isWashClub && (
        <div className="col-md-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            className="powerbi-left-buttons"
            style={{ marginRight: '10px' }}
            onClick={handleUploadPAndL}
          >
            <i className="uil uil-file-upload mr-2"></i>
            {intl.formatMessage({ id: 'uploadPAndL' })}
          </button>
        </div>
      )}
    </div>
  );
};

export default PermissionViewButtons;

PermissionViewButtons.propTypes = {
  permissionLevel: PropTypes.number,
  view: PropTypes.string,
  changeView: PropTypes.func,
  includesSingle: PropTypes.bool,
};
